export default "__VITE_ASSET__B9Coo7RJ__"